module.exports = __webpack_public_path__ + "static/media/tex_door.839fac29.png";